export default __webpack_public_path__ + "static/media/Mask Group 173@3x.c3015a21.png";